import { gql } from '@apollo/client';

export const GET_USER_DOCUSIGN_ENVELOPES_QUERY = gql`
  query GetUserDocuSignEnvelopes($userId: Int!) {
    user(id: $userId) {
      id
      userDocuSignEnvelopes {
        displayName
        contractType
        status
        completedFile
        envelopeUpdatedAt
        userId
        personalizedContractId
      }
    }
  }
`;
